<template>
    <b-container>
        
        <b-row class="m-0 title-row">
           
            <b-img :src="item.ImagePath" class="mr-15"/>
        
            <span class="title-text" 
                  :class="item.ColorClass">
                Вопрос {{ index + 1 }}
            </span>

        </b-row>
        
        <b-row class="m-0 name-question">
            {{item.Name}}
        </b-row>

        <b-row v-if="item.Answer" class="m-0 value-question">
            {{item.Answer}}
        </b-row>
        
    </b-container>
</template>
<script>
import '@/assets/styles/client/form/questionItem.css'

export default {

    props: {
        item: {
            type: Object,
            default: null
        },
        index: {
            type: Number,
            default: 0
        }
    }

}
</script>